import { gql } from 'graphql-tag'

export const GET_EXPIRATION_NOTIFICATION_CONFIGURATIONS = gql`
  query ExpirationNotificationConfigurations {
    expirationNotificationConfigurations {
      expirationNotificationConfigurationId
      category
      offsetDays
      actionType
      recipient
      status
    }
  }
`

export const ESTIMATE_EXPIRATION_BACKFILL = gql`
  query EstimateExpirationBackfill {
    estimateExpirationBackfill {
      applicantCount
      trackerCount
    }
  }
`

export const TRIGGER_EXPIRATION_BACKFILL = gql`
  mutation TriggerExpirationBackfill {
    triggerExpirationBackfill
  }
`

export const SAVE_EXPIRATION_NOTIFICATION_SETTINGS = gql`
  mutation SaveExpirationNotificationSettings(
    $input: SaveExpirationNotificationSettingsInput!
  ) {
    saveExpirationNotificationSettings(input: $input) {
      expirationTrackingEnabled
      configs {
        expirationNotificationConfigurationId
        category
        offsetDays
        actionType
        recipient
        status
      }
    }
  }
`
